/* eslint-disable no-nested-ternary */
import { useCallback } from 'react';
import { StyleSheet, Image } from 'react-native';
import TextButton from '../elements/TextButton';
import { Text, View } from '../Themed';
import Colors from '../../constants/Colors';

// const image = require('../../assets/images/spencer-davis-photo-1-demo.jpg');

export type BreakScreenParamList = {
  questionCategory: string;
  blurb: string[];
  header?: string;
  imageURL?: string;
  onSubmit?: (response: any) => void;
};

export default function BreakScreen(props: BreakScreenParamList) {
  const { questionCategory, blurb, header, imageURL, onSubmit } = props;

  const handleSubmit = useCallback(() => {
    if (typeof onSubmit === 'function') {
      onSubmit('SURVEY_NO_RESPONSE');
    }
  }, [onSubmit]); // prevents unnecessary renders
  console.log(imageURL);
  return (
    <View style={styles.container}>
      {header && (
        <View style={styles.promptContainer}>
          <Text style={styles.promptText}>{header}</Text>
        </View>
      )}
      <View style={styles.textWrapper}>
        {blurb.map((val, ix, arr) => {
          return (
            <Text key={`val_${ix}`} style={styles.blurbText}>
              {val}
            </Text>
          );
        })}
      </View>
      {imageURL && (
        <View style={styles.imageContainer}>
          <Image
            style={{ alignSelf: 'center' }}
            source={{
              uri: imageURL,
              height: 277,
              width: 277,
            }}
          />
        </View>
      )}

      <TextButton
        textStyle={{
          fontSize: 20,
          fontWeight: '600',
          lineHeight: 25,
          letterSpacing: -0.29,
          color: '#F8F5F4',
        }}
        style={[
          styles.buttonWrapper,
          {
            backgroundColor: Colors.snapCalorie.buttonBlue,
          },
        ]}
        onPress={handleSubmit}
        text="Next"
      />
    </View>
  );
}
BreakScreen.defaultProps = {
  onSubmit: () => {},
  header: undefined,
  imageURL: undefined,
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignSelf: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
  textWrapper: {
    // height: 168,
    width: 300,
    marginBottom: 20,
  },
  promptText: {
    fontSize: 20,
    lineHeight: 24,
    fontWeight: '700',
    letterSpacing: 0,
    color: '#14181B',
  },
  promptContainer: {
    maxWidth: 300,
    alignSelf: 'center',
    marginBottom: 30,
  },
  buttonWrapper: {
    borderRadius: 21,
    width: 300,
    height: 50,
    marginVertical: 40,
    alignSelf: 'center',
  },
  buttonText: {
    fontSize: 20,
    fontWeight: '600',
    lineHeight: 25,
    letterSpacing: -0.29,
    color: '#F8F5F4',
  },
  blurbText: {
    color: '#14181B',
    paddingVertical: 10,
    fontSize: 20,
    fontWeight: '500',
    letterSpacing: 0,
    lineHeight: 24,
  },
  imageContainer: {
    backgroundColor: '#fff',
    shadowOpacity: 0.3,
    shadowRadius: 6,
    shadowOffset: {
      height: 3,
      width: 3,
    },
    margin: 30,
    padding: 10,
  },
});
